<template>
  <div v-title data-title="产品预订">
    <section class="container">
      <div class="user-info" v-if="formset.DeliveryAddress!=null" @click="todeliveryaddress()">
        <p class="name">
          {{formset.DeliveryAddress.ReceiverName}}
          <span>{{formset.DeliveryAddress.ReceiverPhone}}</span>
        </p>
        <p class="address">
          {{formset.DeliveryAddress.Province}}{{formset.DeliveryAddress.City}}{{formset.DeliveryAddress.Area}}{{formset.DeliveryAddress.Address}}
        </p>
      </div>
      <div class="delivery-list" v-if="formset.DeliveryAddress==null" @click="todeliveryaddress()">
        <img src="../../assets/img/add.png" width="20px" style="vertical-align: text-top;" /> 请添加收货信息
      </div>

      <div class="neworder-list">
        <div class="neworder-list-logo">
          <img :src="formset.SysCompany.LogoUrl" /><span>{{formset.SysCompany.ShopName}}</span>
          <div style="clear:both;"></div>
        </div>
        <div class="flex">
          <div class="pro-img">
            <a href>
              <img v-lazy="formset.ProductFirstPic" class="lazy-img-fadein" :key="formset.ProductFirstPic" />
            </a>
          </div>
          <div class="details-pro-title">
            <p class="name">{{formset.ProductName}}</p>
            <p class="info">{{formset.ComboName}}</p>
            <p class="tag">
              <span v-for="(tag,$index) in formset.comboTags" :key="$index"
                :style="$index==0?'display:none':''">{{tag}}</span>
            </p>
            <div class="pro-price">
              <span>￥{{formset.SalePrice}}</span>
              <div class="num-input">
                <button v-if="allCount<=1" class="disable">-</button>
                <button v-else @click="allCount=allCount-1 ,Calculaterice()">-</button>
                <input readonly v-on:change="Calculaterice()" type="number" v-model="allCount" />
                <button @click="allCount=allCount+1,Calculaterice()">+</button>
              </div>
            </div>
          </div>
        </div>

        <div class="neworder-list-amount">
          <span class="gray">共{{allCount}}件</span>
          <span>小计</span>
          <span class="orange">￥{{allSalePrice}}</span>
          <span v-if="LoginType==4">省</span>
          <span v-if="LoginType==4" class="orange">￥{{allCommission}}</span>
        </div>
        <div class="pro-tips" v-if="formset.ProductType==-1">
          <p v-if="formset.ComboPriceType==1" class="usedate">使用日期：{{formset.StartDate|
            date('yyyy-MM-dd')}}至{{formset.EndDate| date('yyyy-MM-dd')}}</p>
          <p v-if="formset.ComboPriceType==2" class="usedate">出发日期：{{formset.StartDate| date('yyyy-MM-dd')}}
            天数：{{formset.Days}}天</p>
          <!-- <p v-if="formset.IsRefund==1" class="align-r gray">退款截止时间： {{formset.RefundDate}}</p> -->

          <div class="change">
            <div class="fl" v-if="formset.IsRefund==1">可退</div>
            <div class="fl" v-if="formset.IsRefund==0">不可退</div>
            <div class="fr">退改规则</div>
            <div class="clear"></div>
          </div>
          <div class="rule" v-if="formset.IsRefund==1">
            截止退款日期{{formset.RefundDate}}前未消费的订单可申请退款，
            需收取售价的20%手续费，逾期不可退款
          </div>
          <div class="rule" v-if="formset.IsRefund==0" v-html="formset.ChangeContent"></div>
        </div>
        <div class="pro-tips" v-else>
          <div class="change" v-on:click="refoundshowmethod()">
            <div v-bind:class="[refoundshow ? 'frdown' :'frup']">退改规则</div>
            <div class="clear"></div>
          </div>
          <div class="rule" v-if="refoundshow" v-html="formset.ChangeContent"></div>
        </div>
      </div>

      <!-- <p v-if="formset.IsRefund==1" class="order-num">退款截止时间：{{formset.RefundDate}}</p> -->

      <div class="reserve-info">
        <!-- <div class="title" style="font-size:1.3rem;">收货人信息</div>

        <wvi-input
          label="联系人："
          placeholder="请输入联系人姓名"
          v-model="order.ContactName"
          :validate-info="{errormsg:'联系人不可为空'}"
          required
          ref="101"
          class="inline-input"
        ></wvi-input>

        <wvi-input
          label="手机号码："
          placeholder="请输入手机号码"
          v-model="order.ContactPhone"
          pattern="^[1][3,4,5,7,8,9][0-9]{9}$"
          maxlength="11"
          :validate-info="{errormsg:'联系电话不合法'}"
          required
          ref="102"
          class="inline-input"
        ></wvi-input>

        <div class="weui-cell" v-if="needcheckPhone">
          <div class="weui-cell__hd">
            <label class="weui-label">图形码：</label>
          </div>
          <div class="weui-cell__bd">
            <input
              class="order-yzm"
              type="text"
              placeholder="图形码"
              v-model="PicCodeValue"
              required
              maxlength="4"
            />
          </div>
          <div class="weui-cell__ft">
            <img
              @click="getpiccode()"
              v-bind:src="'data:image/png;base64,'+VerificationCodePic.Base64"
              style="width:100px;height:35px;"
            />
          </div>
        </div>

        <div class="weui-cell" v-if="needcheckPhone">
          <div class="weui-cell__hd">
            <label class="weui-label">短信码：</label>
          </div>
          <div class="weui-cell__bd">
            <input
              v-if="(needcheckPhone)"
              class="order-yzm"
              type="tel"
              placeholder="短信码"
              maxlength="6"
              v-model="order.Password"
            />
          </div>
          <div class="weui-cell__ft">
            <button
              class="weui-btn weui-btn_mini"
              style="width:100px;background:#ff7125;border-radius:0"
              v-if="(needcheckPhone)&&getcodeshow&&order.ContactPhone.length==11&&PicCodeValue.length>0"
              @click="getcode()"
            >获取验证码</button>
            <button
              class="weui-btn weui-btn_mini"
              style="width:100px;background:#ff7125;border-radius:0"
              v-if="(needcheckPhone)&&getcodeshow&&(order.ContactPhone.length!=11||PicCodeValue.length==0)"
              @click="getcode()"
            >获取验证码</button>
            <button
              class="weui-btn weui-btn_mini"
              style="width:100px;background:#ccc;border-radius:0"
              v-if="(needcheckPhone)&&!getcodeshow"
            >{{waitminutes}}秒</button>
          </div>
        </div>-->

        <div class="inline-input">
          <wv-input placeholder="请输入备注" label="备注：" v-model="order.Memo" :max-length="100"></wv-input>
        </div>
      </div>

      <!--付款方式-->
      <div class="payment">
        <a v-if="formset.Draws.length > 0" href="javascript:void(0)" class="block" @click="changeDrawInfo()">
          <div class="link-t">优惠</div>
          <div class="link-txt" v-if="Draw!=null">
            ￥{{ Draw.Price
            }}{{ Draw.FullPrice == 0 ? "" : "(满" + Draw.FullPrice + ")" }}
          </div>
          <div class="link-txt" v-if="Draw==null">
            不使用优惠券
          </div>
        </a>
        <a href="javascript:void(0)" class="block">
          <div class="link-t">付款方式</div>
          <div class="link-txt">微信</div>
        </a>
        <a href="javascript:void(0)" class="block">
          <div class="link-t">运费</div>
          <div v-if="!isnotFreeArea&&formset.ComboFreightTemplate.IsFreeShipping==1" class="link-txt">包邮</div>
          <div v-if="isnotFreeArea&&formset.ComboFreightTemplate.IsFreeShipping==1" class="link-txt">￥{{currentPostage}}
          </div>
          <div @click="showPostage()" v-if="formset.ComboFreightTemplate.IsFreeShipping==0" class="link-txt">
            ￥{{currentPostage}}</div>
        </a>
      </div>
    </section>

    <!--优惠选择-->
    <wv-popup :visible.sync="DrawInfo" style="width: 100%; padding: 20px; padding-bottom: 100px" class="pop-produce">
      <div class="pop-pro-select">
        <p>选择优惠券</p>
        <div class="select-btn">
          <button @click="onChangeDraw()">不使用</button>
          <button @click="onChangeDraw(model)" :class="model == Draw ? 'active' : ''"
            v-for="(model, $index) in formset.Draws" :key="$index">
            ￥{{ model.Price
            }}{{ model.FullPrice == 0 ? "" : "(满" + model.FullPrice + ")" }}
          </button>
        </div>
      </div>
    </wv-popup>

    <footer class="fix-b">
      <p class="tips">
        <span>提交订单成功后，请在30分钟内完成付款。</span>
      </p>
      <div class="bottom-btn">
        <p class="btn-info">
          总金额
          <span v-if="LoginType==4" class="orange">{{(allSalePrice-allCommission+currentPostage -
            DrawPrize)|currency('￥',2)}}</span>
          <span v-if="LoginType==5" class="orange">{{(allSalePrice-0+currentPostage -
            DrawPrize)|currency('￥',2)}}</span>
        </p>
        <button class="sub" @click="confirm()">提交订单</button>
      </div>
    </footer>
    <wv-popup :visible.sync="showchoosePostage" :height="200" v-if="!isnotFreeArea">
      <wv-group>
        <wv-cell v-for="(tag,$index) in formset.ComboFreightTemplate.ExpressAmountInfo" :key="$index"
          :title="tag.LogisticsName|filterdictbyid(69)" :value="'￥'+tag.Amount" @click="choosePostage(tag.Amount)" />
      </wv-group>
    </wv-popup>
    <wv-popup :visible.sync="showchoosePostage" :height="200" v-if="isnotFreeArea">
      <wv-group>
        <wv-cell v-for="(tag,$index) in formset.ComboFreightTemplate.ExpressAmountInfo" :key="$index"
          :title="tag.LogisticsName|filterdictbyid(69)" :value="'￥'+(tag.Amount+formset.ComboFreightTemplate.Postage)"
          @click="choosePostage(tag.Amount)" />
      </wv-group>
    </wv-popup>
  </div>
</template>

<script>
  import { Toast } from "we-vue";
  import thumb from "../../assets/logo.png";
  import { Dialog } from "we-vue";

  export default {
    name: "oldproductpreorder",
    data: function () {
      return {
        LoginType: -1, //(-1=未登录/4=家游客/5=直客)
        formset: {
          SysCompany: {
            ShopName: "",
            CreateTime: "",
            ProductCount: 1
          }
        },
        deliveryAddressID: 0,
        allCount: 1,
        allSalePrice: 0,
        allCommission: 0,
        allSettlementPrice: 0,
        order: { Memo: "", ContactPhone: "" },
        getcodeshow: true,
        waitminutes: "",
        codetimer: null,
        VerificationCodePic: { OnceString: "" }, //图形验证码信息
        PicCodeValue: "", //图形验证码值
        needcheckPhone: false,
        SubmitOrderCount: 0, //提交订单次数
        refoundshow: false,
        isnotFreeArea: false,
        currentPostage: 0,
        showchoosePostage: false,
        DrawInfo: false,
        Draw: null,
        DrawPrize: 0,
      };
    },
    created: function () {
      var deliveryAddressID = localStorage.getItem("chooseaddress");
      if (
        deliveryAddressID != null &&
        deliveryAddressID != undefined &&
        deliveryAddressID.length > 0
      ) {
        this.deliveryAddressID = deliveryAddressID;
        localStorage.removeItem("chooseaddress");
      }
      this.allCount = parseInt(this.$route.query.allCount);
      this.InitProductpreorder();
      this.getpiccode();
    },
    computed: {

      Calculaterice: function () {
        (this.allSalePrice = (this.allCount * this.formset.SalePrice).toFixed(2)),
          (this.allCommission = (this.allCount * this.formset.Commission).toFixed(
            2
          )),
          (this.allSettlementPrice = (
            this.allCount * this.formset.SettlementPrice
          ).toFixed(2));
          if (this.formset.Draws.length > 0 && this.Draw != null) {
          this.onChangeDraw(this.Draw);
        }
      }
    },
    methods: {
      todeliveryaddress: function () {
        this.$router.push({
          path: "/page/deliveryaddress",
          query: { type: "chooseaddress" }
        });
      },
      //验证
      validatesave: function () {
        var com = this.$refs;
        var flag = true;
        for (var c in com) {
          if (this.$refs[c] != undefined) {
            if (this.$refs[c].length != undefined) {
              this.$refs[c][0].validate();
              flag = this.$refs[c][0].valid;
            } else {
              this.$refs[c].validate();
              flag = this.$refs[c].valid;
            }
            if (!flag) return flag;
          }
        }
        return flag;
      },
      refoundshowmethod() {
        this.refoundshow = !this.refoundshow;
      },
      //确认下单
      confirm: function () {
        //_hmt.push(["_trackEvent", "订单", "提交", "提交订单"]);
        if (this.formset.DeliveryAddress == null) {
          Toast.fail("请选择收货地址");
          return;
        }
        if (!this.validatesave()) {
          Toast.fail("联系电话不合法");
          return;
        }
        if (this.needcheckPhone) {
          this.checkcode();
        } else {
          this.submitorder();
        }
      },
      //提交订单
      submitorder: function () {
        this.$store.commit("showLoading");
        this.SubmitOrderCount += 1;
        if (this.SubmitOrderCount > 1) {
          //只可提交一次
          return;
        }
        //判断是否可发货
        var checkenable = false;
        if (
          this.formset.ComboFreightTemplate.NotFreeShippingArea != null &&
          this.formset.ComboFreightTemplate.NotFreeShippingArea != ""
        ) {
          for (
            var i = 0;
            i < this.formset.ComboFreightTemplate.NotFreeShippingArea.length;
            i++
          ) {
            if (
              this.formset.ComboFreightTemplate.NotFreeShippingArea[i] ==
              this.formset.DeliveryAddress.City
            ) {
              checkenable = true;
            }
          }
        }
        if (
          this.formset.ComboFreightTemplate.EnableShippingArea != null &&
          this.formset.ComboFreightTemplate.EnableShippingArea != ""
        ) {
          for (
            var i = 0;
            i < this.formset.ComboFreightTemplate.EnableShippingArea.length;
            i++
          ) {
            if (
              this.formset.ComboFreightTemplate.EnableShippingArea[i] ==
              this.formset.DeliveryAddress.City
            ) {
              checkenable = true;
            }
          }
        }

        if (!checkenable) {
          this.$store.commit("hideLoading");
          this.SubmitOrderCount = 0; //提交失败，提交次数置为0，可再次提交
          //Toast.fail("该地区目前尚不发货，请选择其他收货地址!");
          Dialog.alert({
            title: "提示信息",
            message: "该地区目前尚不发货，请选择其他收货地址!"
          }).then(() => {
            this.$router.push({
              path: "/page/deliveryaddress",
              query: {
                type: "chooseaddress"
              }
            });
          });
          return;
        }

        var data = this.order;
        data["AllCount"] = this.allCount;
        data["ComboPriceGuid"] = this.formset.ComboPriceGuid;
        var disid = this.$route.query.disid;
        if (disid != undefined && disid != null && disid.length > 0) {
          data["DisSysUserGuid"] = disid;
        }
        var stype = this.$route.query.stype;
        if (stype != undefined && stype != null && stype.length > 0) {
          data["IsPlatOrder"] = true;
        } else {
          data["IsPlatOrder"] = false;
        }
        //2019/12/16 收货地址id赋值disid无关
        data["DeliveryAddressID"] = this.deliveryAddressID;
        data["currentPostage"] = this.currentPostage;
        //增加可以不使用优惠券的逻辑-待测试
        if (this.formset.Draws.length > 0 && this.Draw != null) {
          data["TbDrawWinRecord"] = this.Draw.TbDrawWinRecord;
          data["FullPrice"] = this.Draw.FullPrice;
          data["Price"] = this.Draw.Price;
        } else {
          data["TbDrawWinRecord"] = 0;
          data["FullPrice"] = 0;
          data["Price"] = 0;
        }
        this.$http
          .post(this.GLOBAL.BASE_URL + "api/tborder/submitorder", data, {
            emulateJSON: true
          })
          .then(function (d) {
            var rep = JSON.parse(d.bodyText);
            if (rep.Success) {
              this.$router.push({
                path: "/page/orderdetail",
                query: {
                  OrderGuid: rep.Data,
                  type: "pay"
                }
              });
            } else {
              this.SubmitOrderCount = 0; //提交失败，提交次数置为0，可再次提交
              Toast.fail(rep.Message);
            }
            this.$store.commit("hideLoading");
          });
      },
      changeDrawInfo: function () {
        this.DrawInfo = true;
      },
      onChangeDraw: function (value) {
        this.Draw = value;
        //支持不使用优惠券-待测试，value空时不使用
        if (this.LoginType == 4) {
          if (this.Draw == null || this.allSalePrice - this.allCommission < this.Draw.FullPrice) {
            this.DrawPrize = 0;
          } else {
            if (this.allSalePrice - this.allCommission > this.Draw.Price) {
              this.DrawPrize = this.Draw.Price;
            } else {
              this.DrawPrize = this.allSalePrice - this.allCommission - 0.01;
            }
          }
        }
        if (this.LoginType == 5) {
          if (this.Draw == null || this.allSalePrice < this.Draw.FullPrice) {
            this.DrawPrize = 0;
          } else {
            if (this.allSalePrice - this.allCommission > this.Draw.Price) {
              this.DrawPrize = this.Draw.Price;
            } else {
              this.DrawPrize = this.allSalePrice - this.allCommission - 0.01;
            }
          }
        }
        this.DrawInfo = false;
      },
      //获取图形验证码
      getpiccode: function () {
        this.$http
          .get(this.GLOBAL.BASE_URL + "api/login/getverificationcodepic", {
            params: { codeGuid: this.VerificationCodePic.OnceString }
          })
          .then(
            function (d) {
              var rep = JSON.parse(d.bodyText);
              if (rep.Success) {
                this.VerificationCodePic = rep.Data;
              } else {
                Toast.fail(rep.Message);
              }
            },
            function (d) {
              console.log(d);
            }
          );
      },
      //验证验证码
      checkcode: function () {
        if (this.order.ContactPhone == "") {
          Toast.fail("手机号不能为空");
          return;
        }
        if (
          this.PicCodeValue == undefined ||
          this.PicCodeValue == null ||
          this.PicCodeValue == ""
        ) {
          Toast.fail("图形验证码不能为空");
          return;
        }

        if (
          this.order.Password == undefined ||
          this.order.Password == null ||
          this.order.Password == ""
        ) {
          Toast.fail("点击获取验证码填写短信码");
          return;
        }
        this.$http
          .get(this.GLOBAL.BASE_URL + "api/login/checkverificationcode", {
            params: {
              telephone: this.order.ContactPhone,
              code: this.order.Password,
              loginType: 5
            }
          })
          .then(
            function (d) {
              var rep = JSON.parse(d.bodyText);
              if (rep.Success) {
                this.LoginType = 5;
                this.submitorder();
              } else {
                this.getpiccode();
                Toast.fail(rep.Message);
              }
            },
            function (d) {
              console.log(d);
            }
          );
      },
      //获取验证码
      getcode: function () {
        if (this.order.ContactPhone == "") {
          Toast.fail("手机号不能为空");
          return;
        }
        if (this.PicCodeValue == "") {
          Toast.fail("图形验证码不能为空");
          return;
        }
        const TIME_COUNT = 60;
        if (!this.codetimer) {
          this.waitminutes = TIME_COUNT;
          this.getcodeshow = false;
          this.codetimer = setInterval(() => {
            if (this.waitminutes > 0 && this.waitminutes <= TIME_COUNT) {
              this.waitminutes--;
            } else {
              this.getcodeshow = true;
              clearInterval(this.codetimer);
              this.codetimer = null;
            }
          }, 1000);
        }
        this.$http
          .get(this.GLOBAL.BASE_URL + "api/login/getverificationcode", {
            params: {
              picCode: this.PicCodeValue,
              onceString: this.VerificationCodePic.OnceString,
              telephone: this.order.ContactPhone,
              loginType: 5
            }
          })
          .then(
            function (d) {
              var rep = JSON.parse(d.bodyText);
              if (rep.Success) {
              } else {
                this.waitminutes = 0;
                this.getpiccode();
                Toast.fail(rep.Message);
              }
            },
            function (d) {
              console.log(d);
            }
          );
      },
      choosePostage: function (amount) {
        if (this.isnotFreeArea) {
          this.currentPostage =
            this.formset.ComboFreightTemplate.Postage + amount;
        } else {
          this.currentPostage = amount;
        }

        this.showchoosePostage = false;
      },
      showPostage: function () {
        this.showchoosePostage = true;
      },
      InitProductpreorder: function () {
        this.$http
          .get(this.GLOBAL.BASE_URL + "api/tbproduct/getproductpreorder", {
            params: {
              type: this.$route.query.type,
              typeofguid: this.$route.query.typeofguid,
              deliveryAddressID: this.deliveryAddressID
            }
          })
          .then(function (d) {
            var rep = JSON.parse(d.bodyText);
            if (rep.Success) {
              this.formset = rep.Data;
              if (this.formset.ProductName.length >= 27) {
                this.formset.ProductName =
                  this.formset.ProductName.substring(0, 27) + "...";
              }
              if (
                this.formset.DeliveryAddress != null &&
                this.formset.DeliveryAddress != undefined
              ) {
                this.deliveryAddressID = this.formset.DeliveryAddress.ID;
              } else {
                Dialog.alert({
                  title: "提示信息",
                  message: "您还没有收货地址，请先录入收货地址"
                }).then(() => {
                  this.$router.push({
                    path: "/page/deliveryaddressadd",
                    query: {
                      //type: "chooseaddress"
                    }
                  });
                });
              }
              this.LoginType = this.formset.LoginType;
              this.order.ContactName = this.formset.ContactName;
              this.order.ContactPhone = this.formset.ContactPhone;
              this.allSalePrice = this.formset.SalePrice;
              this.allCommission = this.formset.Commission;

              this.order.ContactName = this.formset.DeliveryAddress.ReceiverName;
              this.order.ContactPhone = this.formset.DeliveryAddress.ReceiverPhone;

              if (
                this.order.ContactPhone == undefined ||
                this.order.ContactPhone == null ||
                this.order.ContactPhone == ""
              ) {
                this.needcheckPhone = true;
              }
              if (
                this.formset.ComboFreightTemplate.NotFreeShippingArea !=
                undefined &&
                this.formset.ComboFreightTemplate.NotFreeShippingArea != null &&
                this.formset.ComboFreightTemplate.NotFreeShippingArea.length > 0
              ) {
                for (
                  var i = 0;
                  i <
                  this.formset.ComboFreightTemplate.NotFreeShippingArea.length;
                  i++
                ) {
                  if (
                    this.formset.ComboFreightTemplate.NotFreeShippingArea[i] ==
                    this.formset.DeliveryAddress.City
                  ) {
                    this.isnotFreeArea = true;
                  }
                }
              }

              if (
                this.isnotFreeArea &&
                this.formset.ComboFreightTemplate.IsFreeShipping == 1
              ) {
                this.currentPostage = this.formset.ComboFreightTemplate.Postage;
                this.showchoosePostage = false;
              }
              if (
                this.isnotFreeArea &&
                this.formset.ComboFreightTemplate.IsFreeShipping == 0
              ) {
                this.currentPostage =
                  this.formset.ComboFreightTemplate.Postage +
                  this.formset.ComboFreightTemplate.ExpressAmountInfo[0].Amount;
              }
              if (
                !this.isnotFreeArea &&
                this.formset.ComboFreightTemplate.IsFreeShipping == 0
              ) {
                this.currentPostage = this.formset.ComboFreightTemplate.ExpressAmountInfo[0].Amount;
              }
              this.Calculaterice();
            } else {
              Toast.fail(rep.Message);
            }
          });
      }
    }
  };
</script>

<style>
  .inline-input div.weui-cell {
    padding: 10px 5px;
  }

  .waring-msg {
    position: fixed;
    bottom: 50px;
    width: 100%;
    line-height: 40px;
    text-align: center;
    background: #efeff4;
    font-size: 0.9em;
  }

  .order-price {
    width: 50%;
    height: 50px;
    line-height: 50px;
    text-align: center;
    background-color: #efeff4;
    color: #ff7125;
  }

  .sumitorder {
    width: 50%;
    height: 50px;
    line-height: 50px;
    text-align: center;
    color: #efeff4;
    font-weight: bolder;
    background-color: #ff7125;
    /* background-image: -webkit-linear-gradient(left, #FF4500, #f4802a);
  background-image: -moz- oldlinear-gradient(left, #FF4500, #f4802a);
  background-image: linear-gradient(to right, #FF4500, #f4802a); */
  }
</style>


// WEBPACK FOOTER //
// src/components/combo/oldproductpreorder.vue